import {
  Component,
  EventEmitter,
  Input,
  Output,
  forwardRef,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import {
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
  MomentDateAdapter,
} from '@angular/material-moment-adapter';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from '@angular/material/core';
import { v4 as uuid } from 'uuid';
import { FormInput } from '../_form-input';
import * as _moment from 'moment';
const moment = _moment as any;

const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'input-date',
  templateUrl: './input-date.component.html',
  styleUrls: ['./input-date.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputDateComponent),
      multi: true,
    },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class InputDateComponent implements FormInput, ControlValueAccessor {
  @Input() value: any;
  inputValue: string = '';
  @Input() id: string = uuid();
  @Input() name: string = 'id';
  @Input() label: string = 'Input';
  @Input() placeholder?: string;

  @Input() error: string = '';

  @Input() type: string = 'text';
  @Input() disabled: boolean = false;
  @Input() showSuccessIcon: boolean = false;

  visibleValue: boolean = false;

  @Output() onChange$: EventEmitter<any> = new EventEmitter<any>();
  @Output() onFocus$: EventEmitter<void> = new EventEmitter<void>();
  @Output() focusOut$: EventEmitter<void> = new EventEmitter<void>();

  onChange: any = () => {};
  onTouched: any = () => {};

  writeValue(value: any): void {
    if (value !== undefined) {
      this.value = value;
      if (value) {
        this.inputValue = moment(value).format('DD/MM/YYYY');
      } else {
        this.inputValue = '';
      }
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  emitChange(value: any): void {
    this.value = value;
    this.onChange(value);
    this.onChange$.emit(value);
  }

  onInputChange(value: string): void {
    this.inputValue = value;
    if (value && value.length === 10) {
      const date = moment(value, 'DD/MM/YYYY');
      if (date.isValid()) {
        this.value = date;
        this.onChange(this.value);
        this.onChange$.emit(this.value);
      }
    } else if (!value) {
      this.value = null;
      this.onChange(null);
      this.onChange$.emit(null);
    }
  }

  onPickerChange(event: any): void {
    const value = event.value;
    this.value = value;
    if (value) {
      this.inputValue = moment(value).format('DD/MM/YYYY');
    }
    this.onChange(value);
    this.onChange$.emit(value);
  }

  emitFocus(): void {
    this.onTouched();
    this.onFocus$.emit();
  }

  emitFocusOut(): void {
    this.focusOut$.emit();
  }
}
